import { axiosInstance, requestConfig } from 'network/apis';

import { URL_SYSTEM } from "utils/constants";

export const callShopClientRealTimeControlOptionSetting = async (shopGuid) => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, `/shop/${shopGuid}/real-time-control-option-setting`));
};

export const callEditShopClientRealTimeControlOptionSetting = async (shopGuid, data) => {
    return await axiosInstance(requestConfig('put', URL_SYSTEM, `/shop/${shopGuid}/real-time-control-option-setting`, data));
};